import { render, staticRenderFns } from "./MyGigs.htm?vue&type=template&id=c27c6d04&scoped=true&"
import script from "./MyGigs.ts?vue&type=script&lang=js&"
export * from "./MyGigs.ts?vue&type=script&lang=js&"
import style0 from "./MyGigs.scss?vue&type=style&index=0&id=c27c6d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27c6d04",
  null
  
)

export default component.exports